import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  ICategoryCityLevelPayload,
  ICategoryListingResponseAction,
  ICategoryProductsResponse,
  ICategoryProductUpdatePayload,
  IGetQueryParams,
} from "../../interfaces/Index";
import {
  fetchCategoriesForCityApiCall,
  fetchCategoryProductsForCityApiCall,
  getCategoriesApiCall,
  reorderCategoryProductsForCityApiCall,
  updateCityLevelCategoryApiCall,
} from "../sources/CategorySource";

export const fetchCategoriesInit = () => ({
  type: actionTypes.GET_CATEGORIES_LIST_INIT,
});

export const fetchCategoriesSuccess = (
  payload: ICategoryListingResponseAction | null
) => ({
  type: actionTypes.GET_CATEGORIES_LIST_SUCCESS,
  payload,
});

export const fetchCategoriesFail = (error: string | object | null) => ({
  type: actionTypes.GET_CATEGORIES_LIST_FAIL,
  error,
});

export const updateCityLevelCategoryInit = () => ({
  type: actionTypes.UPDATE_CITY_LEVEL_CATEGORY_INIT,
});

export const updateCityLevelCategorySuccess = () => ({
  type: actionTypes.UPDATE_CITY_LEVEL_CATEGORY_SUCCESS,
});

export const updateCityLevelCategoryFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_CITY_LEVEL_CATEGORY_FAIL,
  error,
});

export const reorderCategoryProductsForCityInit = () => ({
  type: actionTypes.REORDER_CATEGORY_PRODUCTS_FOR_CITY_INIT,
});

export const reorderCategoryProductsForCitySuccess = () => ({
  type: actionTypes.REORDER_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS,
});

export const reorderCategoryProductsForCityFail = (
  error: string | object | null
) => ({
  type: actionTypes.REORDER_CATEGORY_PRODUCTS_FOR_CITY_FAIL,
  error,
});

export const fetchCategoryCityListInit = () => ({
  type: actionTypes.FETCH_CATEGORIES_CITY_LIST_INIT,
});

export const fetchCategoryCityListSuccess = (
  payload: ICategoryListingResponseAction
) => ({
  type: actionTypes.FETCH_CATEGORIES_CITY_LIST_SUCCESS,
  payload,
});

export const fetchCategoryCityListFail = (error: string | object | null) => ({
  type: actionTypes.FETCH_CATEGORIES_CITY_LIST_FAIL,
  error,
});

export const fetchCategoryProductsForCityInit = () => ({
  type: actionTypes.FETCH_CATEGORY_PRODUCTS_FOR_CITY_INIT,
});

export const fetchCategoryProductsForCitySuccess = (
  payload: Array<ICategoryProductsResponse>
) => ({
  type: actionTypes.FETCH_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS,
  payload,
});

export const fetchCategoryProductsForCityFail = (
  error: string | object | null
) => ({
  type: actionTypes.FETCH_CATEGORY_PRODUCTS_FOR_CITY_FAIL,
  error,
});

// async actions

export const reorderCategoryProductsForCity =
  (
    categoryId: string,
    cityId: string,
    payload: ICategoryProductUpdatePayload
  ) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(reorderCategoryProductsForCityInit());
    return reorderCategoryProductsForCityApiCall(categoryId, cityId, payload)
      .then(() => dispatch(reorderCategoryProductsForCitySuccess()))
      .catch((e: object | null | string) =>
        dispatch(reorderCategoryProductsForCityFail(e))
      );
  };

export const getCategoriesList =
  (isProductDetailPage: boolean = false, queryParams?: IGetQueryParams) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchCategoriesInit());
    return getCategoriesApiCall(queryParams, isProductDetailPage)
      .then((categories: ICategoryListingResponseAction) =>
        dispatch(fetchCategoriesSuccess(categories))
      )
      .catch((e: object | null | string) => dispatch(fetchCategoriesFail(e)));
  };

export const updateCityLevelCategory =
  (categoryId: string, cityId: string, payload: ICategoryCityLevelPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(updateCityLevelCategoryInit());
    return updateCityLevelCategoryApiCall(categoryId, cityId, payload)
      .then(() => dispatch(updateCityLevelCategorySuccess()))
      .catch((e: object | null | string) =>
        dispatch(updateCityLevelCategoryFail(e))
      );
  };

export const fetchCategoriesForCity =
  (cityId: string, queryParam: IGetQueryParams) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchCategoryCityListInit());
    return fetchCategoriesForCityApiCall(cityId, queryParam)
      .then((categories: ICategoryListingResponseAction) =>
        dispatch(fetchCategoryCityListSuccess(categories))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchCategoryCityListFail(e))
      );
  };

export const fetchCategoryProductsForCity =
  (categoryId: string, cityId: string, queryParam: IGetQueryParams = {}) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchCategoryProductsForCityInit());
    return fetchCategoryProductsForCityApiCall(categoryId, cityId, queryParam)
      .then((products: Array<ICategoryProductsResponse>) =>
        dispatch(fetchCategoryProductsForCitySuccess(products))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchCategoryProductsForCityFail(e))
      );
  };
